import React, { useEffect, useState } from "react";
import Axios from "axios";
import { FaAngleDown } from "react-icons/fa";

const TeamDetails = ({ competition, team, csv, setCsv, onlineSubmission }) => {
  const [teamLeader, setTeamLeader] = useState({});
  const [teamMembers, setTeamMembers] = useState([]);
  const [semisDisabled, setSemisDisabled] = useState(false);
  const [finalsDisabled, setFinalsDisabled] = useState(false);

  const [inSemis, setInSemis] = useState(team.inSemis);
  const [inFinals, setInFinals] = useState(team.inFinals);
  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date) {
    return [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("/");
  }
  const onSemisClick = () => {
    setSemisDisabled(true);
    if (inSemis) {
      Axios.post(
        "https://ashish.moodi.org/competitions/removeSemis_team",
        {
          participant: team.teamId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInSemis(false);
            setSemisDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    } else {
      Axios.post(
        "https://ashish.moodi.org/competitions/intoSemis_team",
        {
          participant: team.teamId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInSemis(true);
            setSemisDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const onFinalsClick = () => {
    setFinalsDisabled(true);
    if (inFinals) {
      Axios.post(
        "https://ashish.moodi.org/competitions/removeFinals_team",
        {
          participant: team.teamId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInFinals(false);
            setFinalsDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    } else {
      Axios.post(
        "https://ashish.moodi.org/competitions/intoFinals_team",
        {
          participant: team.teamId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInFinals(true);
            setFinalsDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  const getTeamLeader = () => {
    Axios.post(
      "https://ashish.moodi.org/competitions/get_leaders",
      { team: team.teamId },
      { headers: { "Content-Type": "application/json" } }
    )
      .then(async (res) => {
        if (res.data && res.data[0]) {
          const leader = res.data[0];
          setTeamLeader(leader);

          if (competition.isOnline) {
            const submission = onlineSubmission.find(
              (element) => element.userTeamId === leader.teamId
            );
            const submittedOn = submission
              ? formatDate(new Date(submission.submittedOn))
              : "";
            const submissionLink = submission ? submission.submissionLink : "";
            const collegeName = leader.collegeName?.replace(/,/g, " ") || "";
            const cityName = leader.cityName?.replace(/,/g, " ") || "";
            const phone = leader.phone?.replace(/,/g, "") || "";
            setCsv(
              (current) =>
                `${current}${leader.teamId},${leader.userName}(Leader),${leader.MI_NO},${phone},${leader.email},${collegeName},${cityName},${submissionLink},${submittedOn}\n`
            );
          } else {
            const collegeName = leader.collegeName?.replace(/,/g, " ") || "";
            const cityName = leader.cityName?.replace(/,/g, " ") || "";
            const phone = leader.phone?.replace(/,/g, "") || "";
            setCsv(
              (current) =>
                `${current}${leader.teamId},${leader.userName}(Leader),${leader.MI_NO},${phone},${leader.email},${collegeName},${cityName}\n`
            );
          }
        } else {
          console.error("No leader data found");
        }
      })
      .catch((err) => console.error("Error fetching leader:", err));
  };

  const getTeamDetails = () => {
    Axios.post(
      "https://ashish.moodi.org/competitions/get_members",
      { team: team.teamId },
      { headers: { "Content-Type": "application/json" } }
    )
      .then((res) => {
        if (res.data && Array.isArray(res.data)) {
          setTeamMembers(res.data);
          res.data.forEach((member) => {
            const collegeName = member.collegeName?.replace(/,/g, " ") || "";
            const cityName = member.cityName?.replace(/,/g, " ") || "";
            const phone = member.phone?.replace(/,/g, "") || "";
            setCsv(
              (current) =>
                `${current}${member.team},${member.userName},${member.MI_NO},${phone},${member.email},${collegeName},${cityName}\n\n`
            );
          });
        } else {
          console.error("Invalid team member data:", res.data);
        }
      })
      .catch((err) => console.error("Error fetching team details:", err));
  };

  useEffect(() => {
    getTeamLeader();
    getTeamDetails();
    // eslint-disable-next-line
  }, [team]);
  return (
    <>
      <tr className="border">
        <td>
          <button
            class="btn btn-outline-secondary"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${team.teamId}`}
            aria-expanded="false"
            aria-controls={team.teamId}
          >
            <FaAngleDown />
          </button>
        </td>
        <td>{teamLeader.userName}(Leader)</td>
        <td>{teamLeader.MI_NO}</td>
        <td>{teamLeader.phone}</td>
        <td>{teamLeader.email}</td>
        {competition.isOnline ? (
          <>
            {semisDisabled ? (
              <td>
                <div className="d-flex justify-content-center align-items-center">
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            ) : (
              <td>
                <div className="d-flex justify-content-center align-items-center">
                  <input
                    class=""
                    type="checkbox"
                    id="inlineCheckbox1"
                    disabled={semisDisabled}
                    checked={inSemis}
                    onClick={onSemisClick}
                  />
                </div>
              </td>
            )}
            {finalsDisabled ? (
              <td>
                <div className="d-flex justify-content-center align-items-center">
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            ) : (
              <td>
                <div className="d-flex justify-content-center align-items-center">
                  <input
                    class=""
                    type="checkbox"
                    id="inlineCheckbox2"
                    value={inFinals}
                    disabled={finalsDisabled}
                    onClick={onFinalsClick}
                  />
                </div>
              </td>
            )}
          </>
        ) : (
          <></>
        )}
        <td className="col-sm-2">{teamLeader.collegeName}</td>
        <td className="col-sm-1">{teamLeader.cityName}</td>
        {competition.isOnline ? (
          <>
            <td className="col-sm-2">
              <a
                href={
                  onlineSubmission.find(
                    (element) => element.userTeamId === team.teamId
                  )
                    ? onlineSubmission.find(
                        (element) => element.userTeamId === team.teamId
                      ).submissionLink
                    : ""
                }
                style={{
                  position: "relative",
                  zIndex: 10,
                }}
              >
                {onlineSubmission.find(
                  (element) => element.userTeamId === team.teamId
                )
                  ? onlineSubmission.find(
                      (element) => element.userTeamId === team.teamId
                    ).submissionLink
                  : ""}
              </a>
            </td>
            <td className="col-sm-1">
              {onlineSubmission.find(
                (element) => element.userTeamId === team.teamId
              )
                ? formatDate(
                    new Date(
                      onlineSubmission.find(
                        (element) => element.userTeamId === team.teamId
                      ).submittedOn
                    )
                  )
                : ""}
            </td>
          </>
        ) : (
          <></>
        )}
      </tr>

      {teamMembers.map((member) => {
        return (
          <tr className="collapse border" id={team.teamId}>
            <td></td>
            <td>{member.userName}</td>
            <td>{member.MI_NO}</td>
            <td>{member.phone}</td>
            <td>{member.email}</td>
            {competition.isOnline ? (
              <>
                <td></td>
                <td></td>
              </>
            ) : (
              <></>
            )}
            <td>{member.collegeName}</td>
            <td>{member.cityName}</td>
          </tr>
        );
      })}
    </>
  );
};

export default TeamDetails;
